export default "__VITE_ASSET__SUc5gtEg__"